module.exports = __webpack_public_path__ + "static/media/cargosImg.af43cd4f.png";